var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCircleWarningRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 4C8.08172 4 4.5 7.58172 4.5 12C4.5 16.4183 8.08172 20 12.5 20C16.9183 20 20.5 16.4183 20.5 12C20.5 7.58172 16.9183 4 12.5 4ZM2.5 12C2.5 6.47715 6.97715 2 12.5 2C18.0228 2 22.5 6.47715 22.5 12C22.5 17.5228 18.0228 22 12.5 22C6.97715 22 2.5 17.5228 2.5 12Z",
    fill: "#CD1812"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14C11.9477 14 11.5 13.5523 11.5 13L11.5 7C11.5 6.44772 11.9477 6 12.5 6C13.0523 6 13.5 6.44772 13.5 7L13.5 13C13.5 13.5523 13.0523 14 12.5 14Z",
    fill: "#CD1812"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 16.5C11 15.6716 11.6716 15 12.5 15C13.3284 15 14 15.6716 14 16.5C14 17.3284 13.3284 18 12.5 18C11.6716 18 11 17.3284 11 16.5Z",
    fill: "#CD1812"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleWarningRed);
export default __webpack_public_path__ + "static/media/icon_circle-warning-red.714c6e0c299bada769b45c0321272ace.svg";
export { ForwardRef as ReactComponent };